"use client";

import { useBuyerStore as _useBuyerStore, BuyerState } from "@/stores/buyer/buyer-store";
import { useComparisonStore as _useComparisonStore, ComparisonState } from "@/stores/comparison-store";
import { useSellerStore as _useSellerStore, SellerState } from "@/stores/seller/seller-store";

// ---------------------------------------------------------------------------
// Buyer store hooks
// ---------------------------------------------------------------------------

/** Select a slice of BuyerState with automatic re-render on change. */
export function useBuyerStoreData<T>(selector: (state: BuyerState) => T): T {
	return _useBuyerStore(selector);
}

/**
 * Access the raw buyer store for imperative `.getState()` calls.
 * Prefer `useBuyerStoreData(selector)` in render paths.
 *
 * @deprecated Import `useBuyerStore` directly from `@/stores/buyer/buyer-store` instead.
 */
export function useBuyerStore(): typeof _useBuyerStore {
	return _useBuyerStore;
}

// ---------------------------------------------------------------------------
// Seller store hooks
// ---------------------------------------------------------------------------

/** Select a slice of SellerState with automatic re-render on change. */
export function useSellerStoreData<T>(selector: (state: SellerState) => T): T {
	return _useSellerStore(selector);
}

// ---------------------------------------------------------------------------
// Comparison store hooks
// ---------------------------------------------------------------------------

/** Select a slice of ComparisonState with automatic re-render on change. */
export function useComparisonStoreData<T>(selector: (state: ComparisonState) => T): T {
	return _useComparisonStore(selector);
}
